export default "__VITE_ASSET__DmRxwROa__"